import React from 'react'
import styles from './styles.module.scss'

function Divider({ className, text = '' }) {
  return text ? (
    <div class={`${styles.dividerWithText} ${className}`}>
      <hr class={styles.left} />
      <span className={styles.text}>{text}</span>
      <hr class={styles.right} />
    </div>
  ) : (
    <hr className={`${styles.divider} ${className}`} />
  )
}

export default Divider
